
import { useState } from "react";
import { Search } from "lucide-react";
import { Input } from "@/components/ui/input";

interface AppSearchInputProps {
  searchQuery: string;
  onSearchChange: (query: string) => void;
  onCancel: () => void;
  placeholder?: string;
}

export const AppSearchInput = ({ 
  searchQuery, 
  onSearchChange, 
  placeholder = "Search apps from catalog..."
}: AppSearchInputProps) => {
  return (
    <div className="relative">
      <Search className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400 w-4 h-4" />
      <Input
        placeholder={placeholder}
        value={searchQuery}
        onChange={(e) => onSearchChange(e.target.value)}
        className="pl-10 focus-visible:ring-0 focus-visible:ring-offset-0 focus-visible:border-black/20"
        autoFocus
      />
    </div>
  );
};
